import React, { useEffect, useState } from 'react';
import { Link, graphql } from 'gatsby';

import Layout from '../components/layout';
import Seo from '../components/seo';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';
import H1HeaderText from '../components/ui/typography/H1HeaderText';
import BaseText from '../components/ui/typography/BaseText';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import '../styles/pages/blog-template.scss';
import FAQSection from '../components/common/FaqSection';
import H2HeaderText from '../components/ui/typography/H2HeaderText';
import { COLORS, FONT_SIZE } from '../constants/enum';
import FloatingCta from '../components/common/FloatingCta';
import { replaceSpaceAndSpecialCharacter, convertDate, replaceWatchWithEmbed } from '../helper/helpers';
import OurBlogs from '../components/common/OurBlogs';
import LinkedInIcon from '../images/inline/linkedin.inline.svg';
const BlogPostTemplate = ({ data, location }) => {
  const [headings, setHeadings] = useState([]);

  const { previous, next, site, prismicPost } = data;
  const siteTitle = site.siteMetadata?.title || `Welcome`;

  const { description, user_image: userImage } = data?.prismicHomePage?.data || {};
  const blogheaderImage = getImage(prismicPost?.data.image);

  const getNestedHeadings = (headingElements) => {
    const nestedHeadings = [];
    headingElements?.forEach((heading) => {
      const { id, innerText: title } = heading;
      if (heading.nodeName === 'H2') {
        nestedHeadings.push({ id, title, items: [], level: Number(heading.nodeName?.charAt(1)) });
      } else if (heading.nodeName === 'H3' && nestedHeadings.length > 0) {
        nestedHeadings[nestedHeadings.length - 1].items.push({
          parentId: nestedHeadings[nestedHeadings.length - 1].id,
          id,
          title,
          level: Number(heading.nodeName?.charAt(1))
        });
      }
    });
    return nestedHeadings;
  };
  useEffect(() => {
    const divArticle = document.querySelector('.blog-content');
    const allHTags = divArticle.querySelectorAll('h2, h3');
    if (allHTags) {
      for (let i = 0; i < allHTags.length; i++) {
        allHTags[i].setAttribute('id', replaceSpaceAndSpecialCharacter(allHTags[i]?.innerText));
      }
    }
    const newheadingElements = Array.from(divArticle.querySelectorAll('h2, h3'));
    const newNestedHeadings = getNestedHeadings(newheadingElements);
    setHeadings(newNestedHeadings);
  }, []);
  return (
    <Layout location={location} title={siteTitle} headerTextColor="text-gray-700">
      {/* <article
        className="blog-post"
        itemScope
        itemType="http://schema.org/Article"
      >
        <header>
          <h1 itemProp="headline">{post.data.title.text}</h1>
          <p>{post.data.date_posted}</p>
        </header>
        <section
          dangerouslySetInnerHTML={{
            __html: post?.data?.post_body?.html || [],
          }}
          itemProp="articleBody"
        />
        <hr />
        <footer>
        </footer>
      </article>
      <nav className="blog-post-nav">
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.url} rel="prev">
                ← {previous.data.title.text}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.url} rel="next">
                {next.data.title.text} →
              </Link>
            )}
          </li>
        </ul>
      </nav> */}
      <div className="blog-container px-8 mx-auto mt-12">
        <H1HeaderText fontWeight="text-normal" title={prismicPost?.data?.title?.text} />
        <BaseText
          fontWeight="text-medium"
          className="mt-6 mb-20"
          title={
            <span>
              {convertDate(prismicPost?.data?.date_posted)} By{' '}
              <a href="#author-section" className="text-orange-500">
                {prismicPost?.data?.author?.document?.data?.name?.text}
              </a>{' '}
            </span>
          }
        />
        <GatsbyImage
          image={blogheaderImage}
          alt={prismicPost?.data?.image?.alt ? prismicPost?.data?.photo?.alt : 'blog-image'}
        />
        <div className="flex flex-col md:flex-row my-12 gap-12">
          <div className="blog-left-section">
            <div className="bg-blue-100 rounded p-4 mb-16">
              <BaseText fontSize={FONT_SIZE?.PX_16} fontWeight="text-bold" className="mb-2" title="Contents" />
              {headings.map((articleHeadings) => (
                <div>
                  <a className="hover:underline text-blue-250" href={`#${articleHeadings?.id}`}>
                    <BaseText
                      className="mb-2"
                      textColor="text-blue-250"
                      fontSize={FONT_SIZE?.PX_14}
                      title={articleHeadings?.title}
                    />
                  </a>
                  {articleHeadings?.items?.map((item) => (
                    <a className="hover:underline text-blue-250" href={`#${item?.id}`}>
                      <BaseText
                        className="mb-2 ml-4"
                        textColor="text-blue-250"
                        fontSize={FONT_SIZE?.PX_14}
                        title={item?.title}
                      />
                    </a>
                  ))}
                </div>
              ))}
            </div>
            <FloatingCta />
          </div>
          <div>
            <div className="blog-content">
              {prismicPost?.data?.body?.map((sliceData, index) => {
                if (sliceData?.slice_type === 'richtext')
                  return <div dangerouslySetInnerHTML={{ __html: sliceData?.primary?.blog_content?.html }}></div>;
                if (sliceData?.slice_type === 'table')
                  return <div dangerouslySetInnerHTML={{ __html: sliceData?.primary?.table_content?.text }}></div>;
                if (sliceData?.slice_type === 'youtube_video') {
                  return (
                    <div className={`my-8 flex justify-center `} key={index}>
                      <iframe
                        loading="lazy"
                        width="100%"
                        height="356"
                        src={replaceWatchWithEmbed(sliceData.primary.youtube_link.url)}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  );
                }
              })}
              <div>
                {prismicPost?.data?.faqs?.lenght > 0 && <h2 className="text-4xl text-medium">FAQs</h2>}
                {prismicPost?.data?.faqs?.map((faq) => (
                  <>
                    <h3 className="text-blue-500 text-2xl text-medium mb-6 "> {faq?.question?.text}</h3>
                    <div className="mb-8" dangerouslySetInnerHTML={{ __html: faq?.answer?.html }}></div>
                  </>
                ))}
              </div>
            </div>
            <div className="p-6 flex gap-8 bg-blue-100 rounded" id="author-section">
              <img
                className="rounded-full author-img"
                src={prismicPost?.data?.author?.document?.data?.photo?.url}
                loading="lazy"
                alt="author-img"
                height={60}
                width={60}
              />
              <div>
                <BaseText fontWeight="text-bold" title={prismicPost?.data?.author?.document?.data?.name?.text} />
                <BaseText
                  fontSize={FONT_SIZE.PX_16}
                  fontWeight="text-medium"
                  textColor="text-gray-300"
                  className="mb-3"
                  title={prismicPost?.data?.author?.document?.data?.about?.text}
                />
                {prismicPost?.data?.author?.document?.data?.linked_in_link?.url && (
                  <a
                    href={prismicPost?.data?.author?.document?.data?.linked_in_link?.url}
                    target="_blank"
                    rel="noreferrer"
                    className="flex gap-2 text-blue-350 hover:underline"
                  >
                    <LinkedInIcon width="16" fill={COLORS?.Blue600} />
                    <BaseText textColor="text-blue-350" title={prismicPost?.data?.author?.document?.data?.name?.text} />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {prismicPost?.data?.our_blog[0]?.linked_blog?.document && (
        <OurBlogs
          title="Related Articles"
          titleFontWeight="text-regular"
          subTitle=""
          bgColor="bg-green-300"
          our_blog={prismicPost?.data?.our_blog}
        />
      )}
    </Layout>
  );
};

export const Head = ({ data }) => {
  const { seo_title, seo_description } = data?.prismicPost?.data || {};
  return <Seo title={seo_title?.text} description={seo_description?.text} />;
};

export default withPrismicPreview(BlogPostTemplate);

export const blogPostQuery = graphql`
  query BlogPostBySlug($id: String!, $previousPostId: String, $nextPostId: String) {
    site {
      siteMetadata {
        title
      }
    }
    prismicPost(id: { eq: $id }) {
      _previewable
      url
      uid
      data {
        title {
          html
          text
        }
        date_posted
        author {
          document {
            ... on PrismicAuthor {
              id
              data {
                name {
                  text
                }
                photo {
                  url
                }
                linked_in_link {
                  url
                }
                about {
                  text
                }
              }
              uid
            }
          }
        }
        image {
          alt
          gatsbyImageData(height: 501, width: 920, placeholder: DOMINANT_COLOR)
          alt
        }
        body {
          ... on PrismicPostDataBodyRichtext {
            primary {
              blog_content {
                html
              }
            }
            slice_type
          }
          ... on PrismicPostDataBodyTable {
            id
            primary {
              table_content {
                text
              }
            }
            slice_type
          }
          ... on PrismicPostDataBodyYoutubeVideo {
            id
            primary {
              youtube_link {
                url
              }
            }
            slice_type
          }
        }
        faqs {
          answer {
            html
          }
          question {
            text
          }
        }
        our_blog {
          linked_blog {
            document {
              ... on PrismicPost {
                uid
                data {
                  description {
                    text
                  }
                  title {
                    text
                  }
                  image {
                    url
                    alt
                  }
                }
              }
            }
          }
        }
        seo_title {
          text
        }
        seo_description {
          text
        }
      }
    }
    previous: prismicPost(uid: { eq: $previousPostId }) {
      uid
      url
      data {
        title {
          text
        }
      }
    }
    next: prismicPost(uid: { eq: $nextPostId }) {
      uid
      url
      data {
        title {
          text
        }
      }
    }
  }
`;
